import { NgModule } from '@angular/core';
import { AmdHeroComponent } from './hero.component';
export class AmdHeroModule {
}
AmdHeroModule.decorators = [
    { type: NgModule, args: [{
                declarations: [AmdHeroComponent],
                exports: [AmdHeroComponent]
            },] },
];
/**
 * @nocollapse
 */
AmdHeroModule.ctorParameters = () => [];
function AmdHeroModule_tsickle_Closure_declarations() {
    /** @type {?} */
    AmdHeroModule.decorators;
    /**
     * @nocollapse
     * @type {?}
     */
    AmdHeroModule.ctorParameters;
}
//# sourceMappingURL=hero.module.js.map
//# sourceMappingURL=hero.module.js.map
